import InsuranceCardSVG from "images/Icons/KickerCredit.inline.svg"
import { css, f, styled } from "library/styled"
import type { ReactNode } from "react"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function Kicker({
	children,
	className,
	doubleIcon = false,
	size,
	isTransparent = false,
}: {
	children: ReactNode
	className?: string
	doubleIcon?: boolean
	size: "small" | "large"
	isTransparent?: boolean
}) {
	return (
		<Wrapper
			className={className}
			doubleIcon={doubleIcon}
			size={size}
			isTransparent={isTransparent}
		>
			<InsuranceCardSVG />
			<p>{children}</p>
			{doubleIcon && <InsuranceCardSVG />}
		</Wrapper>
	)
}

const Wrapper = styled(
	"div",
	({
		doubleIcon,
		size,
		isTransparent,
	}: {
		doubleIcon: boolean
		size: "small" | "large"
		isTransparent: boolean
	}) => {
		return {
			...f.responsive(css`
				display: flex;
				align-items: center;
				${size === "small" ? textStyles.titleS : textStyles.titleR};
				color: ${colors.green200};

				svg {
					width: 18px;
					height: 11px;
					opacity: ${isTransparent ? 0.5 : 1};

					&:first-of-type {
						margin-right: ${size === "small" ? "8px" : "12px"};
					}

					&:last-of-type {
						margin-left: ${doubleIcon
							? size === "small"
								? "8px"
								: "12px"
							: ""};
					}
				}
			`),
			...f.tablet(css`
				${textStyles.titleR};
			`),
			...f.mobile(css`
				${textStyles.titleS};
			`),
		}
	},
)
